import React from "react";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

import { useSearchParams, Link as RouterLink } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import { Typography, Box, Stack, Paper, Button } from "@mui/material";

import Page404 from "../../pages/Page404";

import logo from "../../logo.svg";
import { RegistrationStatus } from "../../common/enum";
import { VerificationEmail } from "../../redux/features/authSlice";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

const VerifyAccount = () => {
  const [searchParams] = useSearchParams();
  const verifyToken = searchParams.get("verifyToken");
  const dispatch = useDispatch();
  const [successEmailVerify, setSuccessEmailVerify] = React.useState(false);
  const [errorEmailVerify, setErrorEmailVerify] = React.useState(false);

  const { t } = useTranslation();

  const { translate } = useSelector((state) => state);

  React.useEffect(() => {
    i18next.changeLanguage(translate);
    const data = {
      verificationToken: verifyToken,
      status: RegistrationStatus.pendingApproval,
    };
    dispatch(VerificationEmail({ data }))
      .unwrap()
      .then((response) => {
        setSuccessEmailVerify(true);
      })
      .catch((error) => {
        setErrorEmailVerify(true);
        // alert("Unable to verify E-mail");
      });
  }, [translate]);

  return (
    <>
      {" "}
      {verifyToken === null || verifyToken.length === 0 ? (
        <Page404 />
      ) : (
        <Stack sx={style}>
          <Box sx={{ textAlign: "center" }}>
            <Box mb={8} mt={2} pr={4}>
              <img src={logo} alt="SVG as an image"></img>
            </Box>

            <Paper
              variant="outlined"
              sx={{ maxWidth: 550, padding: "16px", borderRadius: "10px" }}
              className="TypographyAlertaEmail"
            >
              {successEmailVerify && (
                <Typography pb={4} fontWeight="400" variant="h4" fontSize="18px !important"  sx={{textAlign:"-webkit-left"}}>
                  {t("accountVerficationSuccessful")}
                </Typography>
              )}
              {errorEmailVerify && (
                <Typography pb={4} fontWeight="400" variant="h4" fontSize="18px !important" sx={{textAlign:"-webkit-left"}}>
                  {t("alreadyVerifiedEmail")}
                </Typography>
              )}
              <Button
                to="/"
                size="large"
                variant="contained"
                component={RouterLink}
                sx={{
                  textTransform: "none",
                  "&:hover": {
                    color: "#ffffff",
                  },
                  borderRadius:"4px"
                }}
              >
                {t("goToHome")}
              </Button>
            </Paper>
          </Box>
        </Stack>
      )}
    </>
  );
};

export default VerifyAccount;
